import React, { useEffect } from 'react';

const InsulationResistanceTest = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  // Determine headers and default values based on model
  const getModelConfig = () => {
    const model = formData.model || '';
    
    if (model === '4031H-OTI') {
      return {
        header1: 'INSTRUMENT',
        header2: 'OTI/CCU WITH PSU/RI',
        measuredValue: 'Greater than 20M ohms',
      };
    } else if (model === '4031H-WTI') {
      return {
        header1: 'INSTRUMENT',
        header2: 'WTI/CCU WITH PSU/RI',
        measuredValue: 'Greater than 20M ohms',
      };
    } else if (model === '4031-OTI') {
      return {
        header1: 'INSTRUMENT',
        header2: 'OTI',
        measuredValue: 'Greater than 100M ohms',
      };
    } else if (model === '4031-WTI') {
      return {
        header1: 'INSTRUMENT',
        header2: 'WTI',
        measuredValue: 'Greater than 100M ohms',
      };
    } else {
      // Default fallback
      return {
        header1: 'INSTRUMENT',
        header2: 'OTI',
        measuredValue: 'Greater than 100M ohms',
      };
    }
  };

  const modelConfig = getModelConfig();

  // Check if model is one of the specified models that should not show Results row
  const shouldHideResults = formData.model && (
    formData.model === '4031-OTI' || 
    formData.model === '4031-WTI' || 
    formData.model === '4031H-OTI' || 
    formData.model === '4031H-WTI'
  );

  // Auto-populate measured value based on model when model changes
  useEffect(() => {
    if (formData.model && formData.irTest.measuredValue !== modelConfig.measuredValue) {
      updateFormData({
        irTest: {
          ...formData.irTest,
          measuredValue: modelConfig.measuredValue,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.model]);

  const handleInputChange = (field, value) => {
    updateFormData({ 
      irTest: { ...formData.irTest, [field]: value }
    });
  };

  return (
    <div className="form-section">
      <h3>Insulation Resistance Test</h3>
      
      <div className="table-container">
        <table className="test-table">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>No.</th>
              <th>{modelConfig.header1}</th>
              <th>{modelConfig.header2}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>1</td>
              <td><strong>Test voltage</strong></td>
              <td>
                <input
                  type="text"
                  value={formData.irTest.testVoltage}
                  onChange={(e) => handleInputChange('testVoltage', e.target.value)}
                  placeholder="500 VDC"
                />
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>2</td>
              <td><strong>Terminal details</strong></td>
              <td>
                <textarea
                  value={formData.irTest.terminalDetails}
                  onChange={(e) => handleInputChange('terminalDetails', e.target.value)}
                  placeholder="All terminals to earth"
                  rows="2"
                  style={{
                    width: '100%',
                    border: 'none',
                    textAlign: 'left',
                    background: 'transparent',
                    padding: '4px',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                  }}
                />
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>3</td>
              <td><strong>Measured value before & after HV test</strong></td>
              <td>
                <input
                  type="text"
                  value={formData.irTest.measuredValue}
                  onChange={(e) => handleInputChange('measuredValue', e.target.value)}
                  placeholder={modelConfig.measuredValue}
                />
              </td>
            </tr>
            {!shouldHideResults && (
              <tr>
                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>4</td>
                <td><strong>Result</strong></td>
                <td>
                  <select
                    value={formData.irTest.result}
                    onChange={(e) => handleInputChange('result', e.target.value)}
                  >
                    <option value="Pass">Pass</option>
                    <option value="Fail">Fail</option>
                  </select>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default InsulationResistanceTest;


